<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:20:31
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="msgbox">
      <div class="title"></div>
      <template v-if="message.status === 1">
        <div class="content">
          <img :src="imgHost + 'draw_form_txt.png?v=1'" alt="">
          <div class="tip2">当前获得{{ message.exp }}能量值</div>
          <div class="tip1">还差{{ message.difexp }}点能量即可点亮下个天天表情包～<br />再接再厉，100000元奖池等你来瓜分！</div>
        </div> 
        <div class="btns">
          <div class="my_btn" @click="clickClose">继续点亮</div>
        </div>
      </template>
      <template v-else-if="message.status === 2">
        <div class="content">
          <img :src="imgHost + 'draw_form_txt.png?v=1'" alt="">
          <div class="tip1">成功点亮第{{ message.lightNum }}个天天表情包，<br />继续加油！<br />还差{{ message.difexp }}即可点亮下个天天表情包～ 再接再厉，100000元奖池等你来瓜分！</div>
        </div> 
        <div class="btns">
          <div class="my_btn" @click="clickClose">继续点亮</div>
        </div>
      </template>
      <template v-else>
      <div class="content">
        <img :src="imgHost + 'draw_form_txt.png?v=1'" alt="">
        <div class="tip1">成功点亮所有天天表情包！<br />获得100000元奖池瓜分资格！<br />请正确填写以下信息，<br />于活动结束后查收微信零钱通知～</div>
        <div class="input_txt">
          <input @blur="blurInput" v-model="name" type="text" placeholder="姓名：" />
        </div>
        <div class="input_txt">
          <input @blur="blurInput" v-model="mobile" type="tel" placeholder="联系方式：" />
        </div>
        <div class="input_code">
          <div class="left">
            <input @blur="blurInput" v-model="vcode" type="number" placeholder="验证码：" oninput="if(value.length>6)value=value.slice(0,6)" />
          </div>
          <div class="right">
            <div @click="getVcode" v-if="!showVcode">{{getVcodes}}</div>
            <div v-else>{{counts}}s</div>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="my_btn" @click="submit">提交</div>
      </div>
      </template>
      <img
        v-if="message.status != 3"
        class="close"
        @click="clickClose"
        src="https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/close_news.png"
        alt
      />
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast, Indicator } from "mint-ui";
export default {
  props: {},
  data() {
    return {
      value: false,
      title: "",
      message: "",
      callback: null,
      userInfo: this.$userInfo,
      vcode: "",
      name: "",
      mobile: "",
       //选则领奖地址
      userAdress: [],
      addressId: "",
      addressName: '',
      addrList: [],
      addressList: [],
      counts: "",
      timers: null,
      getVcodes: "获取验证码",
      showVcode: false,
      prizeId: 0,
    };
  },
  watch: {
    value: function(newVal) {
      if (newVal) {
        this.message.prizeInfo && this.message.prizeInfo.id && this.getPrizeById(this.message.prizeInfo.id)
        this.showVcode = false;
        clearInterval(this.timers);
        this.timers = null;
        this.vcode = "";
      }
    }
  },
  computed: {},
  methods: {
    //我要推荐
    goShare() {
      this.value = false;
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得佣金，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      this.$modal.share.alert(text).then((res) => {
        if (res == "onSave") {
          this.$goPage("poster");
        }
      });
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 获取对应奖品的地址
    async getPrizeById(prizeId) {
      const data = await this.$httpdf.get(this.apiHost + 'home/prize/getPrizeById', { prizeId: prizeId })
      if (data.code == 0) {
        if (data.data.address) {
          this.addrList = [];
          // debugger
          data.data.address.forEach((v, i) => {
            let obj = {};
            obj.addressId = v.addressId;
            obj.addressName = v.addressName;
            obj.name = v.addressName;
            obj.id = i;
            this.addrList.push(obj);
          });
        }
      } else {
        MessageBox.alert(data.msg);
      }
    },
    selectAddr: function (data) {
      this.userAdress = data;
      console.log(this.userAdress);
      this.addressName = data.addressName;
      this.addressId = data.addressId;
    },
    //获取验证码
    getVcode() {
      const _self = this;
      const TIME_COUNT = 60;
      if (!this.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        //获取验证码
        let url = this.apiHost + `common/smsCode`;
        let data = new FormData();
        data.append("mobile", this.mobile);
        this.$httpdf
          .post(
            url,
            data
          )
          .then((data) => {
            if (data.code == 0) {
              Toast({
                message: "验证码已发送至您的手机",
                duration: 2000,
              });
              if (!_self.timers && _self.mobile) {
                _self.counts = TIME_COUNT;
                _self.showVcode = true;
                _self.timers = setInterval(() => {
                  if (_self.counts > 0 && _self.counts <= TIME_COUNT) {
                    _self.counts--;
                  } else {
                    _self.showVcode = false;
                    clearInterval(_self.timers);
                    _self.timers = null;
                  }
                }, 1000);
              }
            } else {
              MessageBox.alert(data.msg);
            }
          });
      }
    },
    //提交手机号
    async submit() {
      let _self = this;
      if (!_self.name) {
        return MessageBox.alert("请输入姓名", "提示");
      } else if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!this.$util.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.vcode) {
        return MessageBox.alert("请输入验证码", "提示");
      }
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      const data = await this.$httpdf.get(this.apiHost + 'user/saveMobile',
        {
          verCode: this.vcode,
          mobile: this.mobile,
          name: this.name,
        })
      if (data.code == 0) {
        Indicator.close();
        Toast({
          message: "提交成功",
          duration: 2000,
        });
        this.value = false;
        this.callback("cancel")
      } else {
        Indicator.close();
        MessageBox.alert(data.msg);
      }
    },
    clickClose() {
      this.value = false;
      this.callback("cancel")
    }
  },
  created() {
  },
  mounted() {
    if (this.$userInfo) {
      this.name = this.$userInfo.nickName;
    }
    if (this.$mobile) {
      this.mobile = this.$mobile
    }
  }
};
</script>
<style lang="scss" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.msgbox {
  background: #AA1626;
  position: relative;
  width: 310px;
  border-radius: 10px;
  padding: 50px 0 30px;
}

.msgbox .title {
  width: 263px;
  height: 123px;
  background: url( $imgHost + 'draw_form.png?t=3') center 0 / 100% no-repeat;
  position: absolute;
  top: -73px;
  left: 50%;
  transform: translateX(-50%);
}

.msgbox .content {
  width: 226px;
  margin: -3px auto 0;
  text-align: center;
  background: #F4DCB4;
  transform: translateX(0.2%);
  padding: 0 5px 1px;
  box-sizing: border-box;
  border-radius: 0 0 5px 5px;
  img {
    width: 101px;
  }
  .tip2 {
    font-size: 20px;
    font-family: PingFang;
    font-weight: 800;
    color: #AB1726;
    margin-top: 12px;
  }
}

.msgbox .content .tip1 {
  padding: 25px 0;
  font-size: 12px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #AB1726;
  line-height: 150%;
}

.msgbox .content input {
  background: #FFFFFF;
  border-radius: 5px;
  width: 100%;
  height: 36px;
  line-height: 36px;
  text-indent: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #AB1726;
  &::-webkit-input-placeholder{
    color: #999;
  }
}

.msgbox .content .input_txt {
  width: 100%;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  
}

.msgbox .content .input_code {
  width: 100%;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .left {
    flex: 1;
    input {
      width : 100%;
    }
  }
  .right {
    width: 75px;
    height: 36px;
    line-height: 36px;
    background: #D83D3D;
    border-radius: 5px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    margin-left: 15px;
  }
}

.msgbox .my_btn {
  width: 226px;
  height: 35px;
  line-height: 35px;
  background: linear-gradient(0deg, #FCF0CC, #EDC99C);
  box-shadow: 0px 3px 3px 0px rgba(124, 18, 18, 0.22);
  border-radius: 5px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #781616;
  text-align: center;
}

.msgbox .btns {
  display: flex;
  justify-content: center;
  padding-top: 15px;
}

.msgbox .close {
  position: absolute;
  top: -100px;
  right: -2px;
  width: 31px;
  height: 31px;
  z-index: 2000;
}

.input_txt {
  ::v-deep .multiselect__tags {
    height: 36px !important;
    line-height: 36px !important;
    min-height: 36px !important;
    border: 0;
    padding-top: 0;
    padding-left: 15px;
    background: #FFFFFF;
    border-radius: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AB1726;
    .multiselect__input, .multiselect__single{
      background-color: transparent;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0;
      margin: 0;
      line-height: 36px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #AB1726;
    }
    .multiselect__placeholder {
      line-height: 36px !important;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      padding: 0;
      color: #666;
    }
  }
  ::v-deep .multiselect__select {
    height: 36px;
    &::before {
      color: #AB1726;
    }
  }
}
</style>